import { createAsyncThunk } from '@reduxjs/toolkit';

import { getApiErrorMessage } from '../lib/getApiErrorMessage';
import { CustomList } from '../types/CustomListSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

interface FetchCustomListsParams {
    propertyId: string;
}

export const fetchCustomLists = createAsyncThunk<
    CustomList[],
    FetchCustomListsParams,
    ThunkConfig<string>
>('customList/fetchCustomLists', async ({ propertyId }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<{ data: CustomList[] }>(
            `/v1/custom-lists/`,
            { params: { propertyId } },
        );

        return response.data.data ?? [];
    } catch (e) {
        return rejectWithValue(String(getApiErrorMessage(e)));
    }
});
